import React from 'react';

import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { Tabs } from '@telus-uds/components-web';

import { useLocaleContext } from '../../../../context/LocaleContext';
import { TabBarWrapper } from '../../../../form/css';
import EN from '../../../../../EN.json';
import FR from '../../../../../FR.json';

const Navigation = ({ selectedDashboard }) => {
  const local = useLocaleContext();

  const {
  DEFECT_MANAGEMENT: { manageControlTabs } }
  = local === 'en-US' ? EN : FR;
  const history = useHistory();

  return (
    <TabBarWrapper className="mc-tab-nav">
      <Tabs
        itemTokens={{ maxWidth: '900px' }}
        value={selectedDashboard}
        onChange={key => history.push(`/manage-control/${key}`)}
        items={manageControlTabs.map(({ key, label }) => ({
          label,
          id: key
        }))}
      />
    </TabBarWrapper>
  );
};

Navigation.propTypes = {
  selectedDashboard: PropTypes.string.isRequired
};

export default Navigation;
